import select2 from "select2/dist/js/select2.full";

select2($);

// select2 4.1.0 reicht `AjaxAdapter.prototype._normalizeItem` ungebunden an
// Array.map weiter (data/ajax.js), die Methode greift aber auf `this.container`
// zu. Vite bündelt select2 als ES-Modul, dort ist `this` im strict mode
// `undefined`: der Ajax-Success-Callback wirft, bevor die Ergebnisse gerendert
// werden, und das Dropdown bleibt auf "Lade..." stehen.
const AjaxAdapter = $.fn.select2.amd.require("select2/data/ajax");
const normalizeItem = AjaxAdapter.prototype._normalizeItem;
AjaxAdapter.prototype._normalizeItem = function (item) {
	return normalizeItem.call(this || {}, item);
};
